export default __webpack_public_path__ + "static/media/Page24.2705e7c1.txt";